<template>
  <v-data-table
    :expanded="tableMixin_expandedRows"
    :footer-props="{
      'items-per-page-options': [pagination.per_page],
    }"
    :items-per-page="pagination.per_page"
    :headers="tableMixin_displayedHeaders"
    :items="displayedItems"
    :mobile-breakpoint="0"
    :page="pagination.current_page"
    :server-items-length="pagination.total"
    :class="{ 'content-loading': loading }"
    disable-sort
    @update:page="tableMixin_changePage"
    @click:row="tableMixin_onRowClick"
  >
    <template v-slot:item.file="{ item }">
      <a :href="item.uploaded_file_url" target="_blank" download class="link">
        <BaseTruncatedField :text="item.original_name" :truncatedLength="15" />
      </a>
    </template>

    <template v-slot:item.image="{ value }">
      <v-img
        v-if="value"
        :src="$backendUrl(value.image_path)"
        :alt="value.original_name"
        height="100px"
        width="100px"
        class="clickable"
        contain
        @click.stop="viewImages(value)"
      />
    </template>

    <template v-slot:item.url_link="{ item }">
      <a :href="item.url_link" class="link" target="_blank">
        {{ item.url_name }}
      </a>
    </template>

    <template v-slot:item.translatedStatus="{ item }">
      <v-chip
        :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
        class="text-caption persist-opacity"
        label
        small
      >
        {{ item.translatedStatus }}
      </v-chip>
    </template>
    <template v-slot:item.publishedIn="{ item }">
      <div class="preserve-whitespace">{{ getPublishedInString(item) }}</div>
    </template>

    <template v-slot:item.actions="{ item }">
      <BaseActionMenu :actions="getRowActions(item)" :item="item" />
    </template>
    <template v-slot:expanded-item="{ item }">
      <BaseExpandedTableRow
        :colspan="tableMixin_displayedHeaders.length"
        :headers="tableMixin_hiddenHeaders"
        :item="item"
      >
        <template v-slot:item.translatedStatus>
          <v-chip
            :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
            class="text-caption persist-opacity"
            label
            small
          >
            {{ item.translatedStatus }}
          </v-chip>
        </template>
        <template v-slot:item.publishedIn>
          <div class="preserve-whitespace">{{ getPublishedInString(item) }}</div>
        </template>
      </BaseExpandedTableRow>
    </template>
  </v-data-table>
</template>

<script>
import BaseTruncatedField from '@/components/base/BaseTruncatedField';
import BaseActionMenu from './base/BaseActionMenu';
import BaseExpandedTableRow from './base/BaseExpandedTableRow';
import tableMixin from '../mixins/table-mixin';

export default {
  name: 'PublicationsTable',

  components: {
    BaseTruncatedField,
    BaseExpandedTableRow,
    BaseActionMenu,
  },

  mixins: [tableMixin],

  props: {
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    disabledItemIds: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('image'),
          value: 'image',
        },
        {
          text: this.$t('title'),
          value: 'title',
        },
        {
          text: this.$t('secondary_title'),
          value: 'secondary_title',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('url'),
          value: 'url_link',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('file'),
          value: 'file',
          hidden: 'smAndDown',
        },
        {
          text: this.$t('status'),
          value: 'translatedStatus',
          hidden: 'smAndDown',
        },
        {
          text: this.$t('published_in'),
          value: 'publishedIn',
          hidden: 'smAndDown',
        },
        {
          value: 'actions',
          align: 'end',
        },
      ];
    },

    displayedItems() {
      if (!this.items) {
        return [];
      }
      return this.items.map((r) => ({
        ...r,
        translatedStatus: this.$t(
          `contact_status.${r.is_published ? 'published' : 'not_published'}`,
        ),
      }));
    },
  },

  methods: {
    getRowActions() {
      const actions = [
        {
          callback: (p) => this.$emit('edit', p),
          label: this.$t('edit'),
          icon: 'mdi-pencil',
        },
        {
          callback: (p) => this.$emit('delete', p),
          label: this.$t('delete'),
          icon: 'mdi-delete',
        },
      ];
      return actions;
    },

    getPublishedInString(item) {
      const checked = [];
      if (item.show_in_preterm_birth) {
        checked.push(this.$t('preterm_birth'));
      }
      if (item.show_in_premature_baby) {
        checked.push(this.$t('premature_baby'));
      }
      if (item.show_in_lost_baby) {
        checked.push(this.$t('lost_baby'));
      }
      if (item.show_in_already_at_home) {
        checked.push(this.$t('already_at_home'));
      }
      return checked.join(',\n');
    },

    viewImages(image) {
      this.$emit('click:image', image);
    },
  },
};
</script>
